import { ContractListUrlSortField } from "@saleor/createOrder/urls";
import { CustomerContractsSortField } from "@saleor/graphql";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSorCustomertQueryField(
  sort: ContractListUrlSortField
): CustomerContractsSortField {
  switch (sort) {
    case ContractListUrlSortField.contractNo:
      return CustomerContractsSortField.CODE;
    default:
      return undefined;
  }
}

export const getCustomerSortQueryVariables = createGetSortQueryVariables(
  getSorCustomertQueryField
);
